:host {
  height: 100%;

  av-asset{
    display: inline-flex;
    width: 100%;
  }
}
